import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { CommonLabels, dataTable } from '../../models/common.model';
import { MatTableDataSource } from '@angular/material/table';

import { StorageService } from '../../services/storage.service';
import { TableService } from '../../services/table.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { commonLabels } from '../../common.labels';
import { UtilsService } from '../../services/utils.service';

@AutoUnsubscribe()
@Component({
  selector: 'table-landing',
  templateUrl: './table-landing.component.html',
  styleUrls: ['./table-landing.component.scss']
})
export class TableLandingComponent implements OnDestroy, OnChanges {
  className = 'table';
  theme = 'marketplace-default';
  labels: CommonLabels = commonLabels;
  @Input() checkboxes: any;
  @Input() originalData: any;
  @Input() displayedColumns;
  @Input() dataTable: dataTable[];
  @Input() width: number;
  @Input() noDataLabel?: string;
  @Input() view?: string;
  @Input() borderRadius?: string;
  @Input() boxShadow?: string;
  @Input() selectionIncluded?;
  @Input() selectedIncludedElements;
  @Input() dataSourceIncluded;
  @Input() initialSortActive?: string;
  @Input() initialSortDirection?: 'asc' | 'desc';
  @Output() emitGetAllPaginator = new EventEmitter();
  @Output() emitSelected = new EventEmitter();
  /**
   * Notifica al padre del cambio de orden para poder pedirlo a server.
   * El sort local sigue funcionando como fallback si no hay listener.
   */
  @Output() sortChange = new EventEmitter<{ active: string; direction: 'asc' | 'desc' | '' }>();

  dataSource: any;
  matSortActive: any;
  matSortDirection: any;

  constructor(
    private storageService: StorageService,
    private tableService: TableService,
    public utilService: UtilsService
  ) {}

  ngOnChanges(): void {
    if (this.width) {
      this.createTable();
    }
  }

  ngOnInit(): void {
    this.createTable();
  }
  getCondiction(element) {
    return element.hasOwnProperty('_id') ? this.checkboxes[element._id] : this.checkboxes[element];
  }
  createTable() {
    this.dataSource = null;
    this.dataSource = new MatTableDataSource(this.originalData);

    let sortBy = JSON.parse(this.storageService.retrieveListSorting(this.view));
    if (sortBy !== null) {
      this.matSortActive = sortBy.active;
      this.matSortDirection = sortBy.direction;
    } else if (this.initialSortActive) {
      // Fallback: si el padre no tiene preferencia guardada, aplicar el sort
      // inicial declarado vía @Input (ej. name asc para el listado de apps).
      this.matSortActive = this.initialSortActive;
      this.matSortDirection = this.initialSortDirection ?? 'asc';
    }
  }

  public isAllIncludedSelected(): boolean {
    const numSelectedOne = this.selectedIncludedElements.length;
    const numRowsOne = this.dataSourceIncluded.length;
    return numSelectedOne === numRowsOne;
  }

  masterAvailableToggle(): void {
    if (this.isAllIncludedSelected()) {
      this.selectionIncluded.clear();
      this.deselectIncludedElements();
    } else {
      this.dataSourceIncluded.forEach((row) => {
        this.selectionIncluded.select(row);
        this.selectIncludedElements();
      });
    }
    this.emitSelected.emit(this.selectedIncludedElements);
  }

  public deselectIncludedElements(): void {
    this.selectedIncludedElements = [];
    this.emitSelected.emit(this.selectedIncludedElements);
  }

  public selectIncludedElements(filterValue?, filterParameter?): void {
    // If there is no filter, select all contacts
    if (filterParameter === undefined || filterValue === undefined) {
      this.dataSourceIncluded.map((element) => {
        this.selectedIncludedElements.push(element._id);
        // filter repeated elements
        this.selectedIncludedElements = this.selectedIncludedElements.filter(
          (item, index) => this.selectedIncludedElements.indexOf(item) === index
        );
      });
    }
  }

  public onSelectedIncludedChange($event: Event, element: any): any {
    if ($event) {
      this.selectedIncludedElements.push(element._id);
      this.selectedIncludedElements = this.selectedIncludedElements.filter(
        (elm) => elm !== undefined
      );
    } else {
      const index = this.selectedIncludedElements.indexOf(element._id);
      this.selectedIncludedElements = this.selectedIncludedElements.filter(
        (elm) => elm !== undefined
      );
      this.selectedIncludedElements.splice(index, 1);
    }
    this.emitSelected.emit(this.selectedIncludedElements);
  }

  getAllPaginator(size?) {
    if (size === 0) {
      this.emitGetAllPaginator.emit(size);
    } else {
      this.emitGetAllPaginator.emit();
    }
  }

  storeSort(event, view?) {
    const listSort = event;
    if (listSort) {
      this.dataSource.data = this.tableService.storeSort(listSort, this.dataSource.data, view);
    } else {
      this.dataSource.data = this.tableService.storeSort(
        { active: 'online', direction: 'asc' },
        this.dataSource.data,
        view
      );
    }
    // Notificar al padre por si quiere ordenar via server (no rompe a
    // consumidores existentes — si no se suscriben, sigue siendo sort local).
    this.sortChange.emit(event);
  }

  ngOnDestroy(): void {}
}
